import {GameProvider} from '@gongxigames/framework/slotV2/types';

export type SplashScreenConfig = {
    logo: SplashImageConfig;
    watermark?: SplashImageConfig;
};

export type SplashImageConfig = {
    src: string;
    duration: number;
    width: number;
};

export type VersionsInfo = {
    framework: string;
    gameVersion: string;
    clientVersion: string;
    binaryResourcesVersion?: string;
    game: string;
    gameName: string;
    math: string;
    integration: string;
    buildType: string;
    buildDate: number;
    buildNumber: string;
};

export type BuildPropertyType = {
    gameTitle: string;
    env: string;
    operator: string;
    provider: GameProvider;
    versions: VersionsInfo;
    gameProperty: {
        mobilPack?: {
            resolution: string;
            platform: string;
        };
        resourcePaths: {
            binary?: string;
            staticFolder: string;
        };
        skinName: string;
    };
};

export type EnvironmentProperty = {
    buildProperty: BuildPropertyType;
    splashScreenConfig?: SplashScreenConfig;
    cdn: string;
    root: string;
    game_history_list: string;
    sentry_dsn: string;
    sentry_activation: number;
    analytics_activation: number;
    sessionsURL: string;
    keysAndValues?: Record<string, string | boolean | number>;
};
